import { Bl_inv_stock_replenishment_template_filter_supplier_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class StockReplenishmentTemplateFilterSupplierModel extends BaseContainerModel {
  bl_inv_stock_replenishment_template_filter_supplier: Bl_inv_stock_replenishment_template_filter_supplier_RowClass = new Bl_inv_stock_replenishment_template_filter_supplier_RowClass();
}
